<template>
    <div id="app">
        <vue-topprogress ref="topProgress" color="#e3ad78" :minimum="70" :speed="350"></vue-topprogress>
        <div class="wrapper">
            <div class="wrapper-in">
                <formLandModal v-if="isOpenFormLandModal"></formLandModal>
                <AppHeader></AppHeader>
                <main class="content">
                    <router-view/>
                </main>
                <AppFooter :class="{openSidebar: isOpenSendwich}"></AppFooter>
            </div>
        </div>
        <transition
            name="fade"
            mode="out-in"
        >
            <div class="body-overlay" id="body-overlay" @click="closeFormModal()" v-cloak v-if="isOpenFormLandModal"></div>
        </transition>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import formLandModal from '@/components/forms/form-land-modal.vue'
    import cookie from 'vue-cookie'
    export default {
        components: {
            AppHeader,
            AppFooter,
            formLandModal,
        },
        data () {
            return {
                isMobile: false,
                title: '',
            }
        },
        methods: {
            closeFormModal() {
                if (this.isOpenFormLandModal) {
                    cookie.set('legenda_form_land_modal_timer', true, { expires: this.formsData.form_drop_modal.minutes + 'm' });
                    this.$store.commit('Open_FormLandModal', false);
                }
            },
            isMobileCheck() {
                var checkMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                if (checkMobile) {
                    this.isMobile = true
                }
            },
            checkFormLandModal() {
                // console.log(this.salesCard);
                if (this.formsData != null) {
                    if (this.formsData.form_drop_modal != undefined && this.formsData.form_drop_modal.init == 'true') {
                        const seconds = parseInt(this.formsData.form_drop_modal.seconds) * 1000;
                        var timerCockie = cookie.get('legenda_form_land_modal_timer');
                        setTimeout(() => {
                            // console.log(seconds);
                            if (timerCockie == null) {
                                // console.log(seconds, 'SECONDS', timerCockie);
                                this.$store.commit('Open_FormLandModal', true);
                            } 
                            // else { // если кука есть какие то действия при необходимости
                            //     console.log(timerCockie, 'COCKIE TIMER');
                            // }
                        }, seconds);
                    } 
                    // else {
                    //     // console.log('FORM LAND MODAL IS FFFFFALLLLLLSEEEEE ')
                    // }
                }
            },
        },
        computed: mapGetters({
            isOpenSendwich: 'loadOpenSendwich',
            isOpenFormLandModal: 'loadIsOpenFormLandModal',
            formsData: 'loadFormData',
        }),
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }
            this.$store.dispatch('getCrmAuthToken').then((response) => {
                this.$store.dispatch('getSalesCardPageData');
                this.$store.dispatch('getPageSetUp');
                this.$store.dispatch('getSectionsData');
                this.$store.dispatch('getFormsData');
            });
        },
        created () {
            // this.isMobileCheck();
            // document.title = this.title;
        },
        mounted() {
            this.$refs.topProgress.start();
            this.$store.watch(
                (state) => state.indexPromo,
                (newValue) => {
                    if (newValue != null) {
                        var _self = this;
                        var image = new Image();
                        image.onload = function () {
                            _self.$refs.topProgress.done();
                        }
                        image.src = newValue.index_promo_images.img_day;
                    }
                }
            ),
            this.$store.watch(
                (state) => state.forms,
                (newValue) => {
                    if (newValue != null) {
                        this.checkFormLandModal();
                    }
                }
            )
        }

    }
</script>

<style lang="scss">
    @import '@/styles/main.scss';
    .grecaptcha-badge {
        opacity: 0 !important;
        visibility: hidden;
    }
</style>
